import React, { useState, useEffect } from "react";
import BookAppointmentModal from "./BookAppointmentModal";

const AutoBookingModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if this is a page reload (not a navigation)
    const isPageReload = window.performance.navigation.type === 1 || 
                        window.performance.getEntriesByType('navigation')[0]?.type === 'reload';
    
    // Check if modal was already shown in this session
    const modalShown = sessionStorage.getItem('autoBookingModalShown');
    
    // Open modal if it's a page reload and hasn't been shown yet
    if (isPageReload && !modalShown) {
      // Small delay to ensure page is fully loaded
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('autoBookingModalShown', 'true');
      }, 1500); // 1.5 second delay for better UX

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  // Don't render anything if modal is not open
  if (!isOpen) {
    return null;
  }

  return (
    <BookAppointmentModal
      isOpen={isOpen}
      onOpenChange={handleClose}
      treatmentType="general-consultation"
    />
  );
};

export default AutoBookingModal;
